import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityApiRequestUsage } from '@api';

export const getCoreDataSecurityApiRequestUsageSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityApiRequestUsage',
	receive: true,
	request: false,
	requestHandler: getDataSecurityApiRequestUsage,
	retainDataOnRequest: true
});
